import { render, staticRenderFns } from "./DashboardFleetEfficiency.vue?vue&type=template&id=0360e790&scoped=true"
import script from "./DashboardFleetEfficiency.vue?vue&type=script&lang=js"
export * from "./DashboardFleetEfficiency.vue?vue&type=script&lang=js"
import style0 from "./DashboardFleetEfficiency.vue?vue&type=style&index=0&id=0360e790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360e790",
  null
  
)

export default component.exports